import React, { useContext, useState } from 'react';
// import { CHALLENGE_RESULTS } from '../ChallengeResults/graphql/queries'; // TODO: Replaced with REST hook
import { useStartChallenge } from '../../hooks/useStartChallenge';
import { useChallenge } from '../../hooks/useChallenge';
import { makeStyles } from '@material-ui/core/styles';
// import { useQuery } from '@apollo/client'; // TODO: Replaced with React Query REST hook
import { HashLink } from 'react-router-hash-link';
import { useResultsChallenge } from '../../hooks/useResultsChallenge';
import { Container, Button, Box } from '@material-ui/core';
import Layout from '../../common/Layout';
import ChallengeResultHead from '../../common/components/ChallengeResultHead/ChallengeResultHead';
import ChallengeResultSteps from '../../common/components/ChallengeResultSteps/ChallengeResultSteps';
import ChallengeContext from '../../store/challenge-context';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ChallengeDialog from "../../common/components/ChallengeDialog";
import LoadingSpinner from '../../common/components/LoadingSpinner/LoadingSpinner';
//import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  goBackBtn: {
    marginBottom:10,
    [theme.breakpoints.down('xs')]: {
      marginBottom:35,
      fontSize: theme.typography.pxToRem(12),
    },
    '&:hover': {
      color: theme.palette.text.primary,
    },
    '&:focus': {
      outline: 'none',
    },
  },
}));



const ChallengeResults = (props) => {
  // All hooks must be called at the top level, before any early returns
  const classes = useStyles();
  const showDialog = props.match.params.showDialog ? !!parseInt(props.match.params.showDialog, 10) : true;
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  // const [learningTopicFinishedOpen, setLearningTopicFinishedOpen] = useState(showDialog);
  const [hasReadAllDialogs] = useState(!showDialog);
  const [state, setState] = useState({
    challengesToDo: [],
    selectedChallengeDescription: "",
    selectedChallengeType: "",
    selectedChallengeTopic: "",
    selectedChallengeInitialLocation: "",
    selectedChallengeCoach: null,
    selectedChallengeTitle: null,
    selectedChallengeIsValidation: null,
    selectedChallengeDifficulty: null,
    selectedChallengeAverageTime: null,
    open: false
  });
  const [challengeDialogId, setChallengeDialogId] = useState(null);
  const [challengeDialogRestart, setChallengeDialogRestart] = useState(false);
  const { data: challengeData, isLoading: challengeLoading } = useChallenge(challengeDialogId);

  const context = useContext(ChallengeContext);
  // Hook REST per avviare la challenge
  const startChallengeMutation = useStartChallenge();

  // Open dialog for next challenge when challengeData is loaded
  React.useEffect(() => {
    if (challengeDialogId && challengeData && !challengeLoading) {
      const selectedChallenge = challengeData.challengeDefinition ?? {};
      setState((prev) => ({
        ...prev,
        selectedChallengeDescription: selectedChallenge.challengeDescription,
        selectedChallengeInitialLocation: selectedChallenge.steps[0]?.initialLocationSimulation,
        selectedChallengeType: challengeDialogId,
        selectedChallengeLearningTopic: selectedChallenge.challengeLearningTopic,
        selectedChallengeCoach: selectedChallenge.coach,
        selectedChallengeTitle: selectedChallenge.challengeTitle,
        selectedChallengeIsValidation: selectedChallenge.isValidation,
        selectedChallengeDifficulty: selectedChallenge.challengeDifficulty,
        selectedChallengeAverageTime: selectedChallenge.averageTime,
        restart: challengeDialogRestart || false,
        open: true
      }));
    }
  }, [challengeDialogId, challengeData, challengeLoading, challengeDialogRestart]);


  /*const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
    setHasReadAllDialogs(true);
  };*/

  /*const handleLearningTopicFinishedOpen = () => {
    setLearningTopicFinishedOpen(false);
    setSuccessDialogOpen(true);
  };*/

  const challengeId = props.match.params.id;
  
  const {
    data,
    isFetching: loading,
    error
  } = useResultsChallenge(challengeId);

  
  if (loading) {
    return (
      <Layout>
        <LoadingSpinner styles={{ paddingTop: 60 }} />
      </Layout>
    );
  }
  if (error) {
    return (
      <Layout>
        <div>Error! {error.message}</div>
      </Layout>
    );
  }

  // Return early if data is not available yet
  if (!data) {
    return (
      <Layout>
        <LoadingSpinner styles={{ paddingTop: 60 }} />
      </Layout>
    );
  }
  
  const {score, obtainableScore, completedSteps, solution, coach, stepResults, time, totalSteps, nextChallenge, finishedLearningTopic, currentStep, status, blockedSteps, title} = data?.challengeResults || {};
  // Ensure we have all required data before rendering
  if (!coach || !stepResults || score === undefined) {
    return (
      <Layout>
        <LoadingSpinner styles={{ paddingTop: 60 }} />
      </Layout>
    );
  }
  
  if (!hasReadAllDialogs && !successDialogOpen && !finishedLearningTopic) {
    setSuccessDialogOpen(true);
  }

  function handleOpen(id, restart) {
    setChallengeDialogId(id);
    setChallengeDialogRestart(!!restart);
  }



  const handleClose = () => {
    setState({ open: false });
  };


  async function handleSave() {
    const {
      selectedChallengeType,
      selectedChallengeInitialLocation,
      restart
    } = state;
    try {
      const result = await startChallengeMutation.mutateAsync({
        challengeType: selectedChallengeType,
        restart: restart || false
      });
      const id = result.createChallenge?.challengeInstanceId || result.createChallenge?._id;
      props.setChallengeOrigineRoute(context.challengeOrigineRoute);
      props.history.push(`${selectedChallengeInitialLocation}/${id}`);
    } catch (error) {
      console.error('Error starting challenge:', error);
    }
  }

  let btnRoute = null;
  if (context.challengeOrigineRoute) {
    btnRoute = `${context.challengeOrigineRoute}`;
  } else {
    btnRoute = '/';
  }

  const steps = `${completedSteps}/${totalSteps}`;
  const totalScore = `${score}/${obtainableScore}`;
  console.log('nextChallenge:', nextChallenge);
  const nextChallengeId = nextChallenge ? nextChallenge.id : null;
  // const otherCareers = _.sortBy(availableCareers, [(o) => o.status !== 'not started' ]);

  return (
    <Layout>
      <Box
        component="div"
        display="flex"
        justifyContent="space-between">
        <Button
          startIcon={<ArrowBackIcon />}
          component={HashLink}
          to={btnRoute}
          className={classes.goBackBtn}
        >Back to Challenges</Button>
        {nextChallengeId &&
          <Button
            endIcon={<ArrowForwardIcon />}
            onClick={() => { handleOpen(nextChallengeId, true) }}
            className={classes.goBackBtn}
          >Next Challenge</Button>
        }
      </Box>
      <Container className={classes.container} maxWidth="md" disableGutters>
        <ChallengeResultHead
          coach={coach}
          totalSteps={steps}
          totalTime={time}
          title={title}
          totalScore={totalScore}
          solutionDesc={"Are you struggling to understand why you mistake on some steps? No worries, check the solution below. We've made for you a complete step-by-step solution guide to help you to understand each step's challenge."}
          solutionSrc={solution}
        />
        <ChallengeResultSteps
          stepResults={stepResults}
          challengeId={challengeId}
          currentStep={currentStep}
          status={status}
          blockedSteps={blockedSteps}
        />
      </Container>
      <ChallengeDialog
        //title="Start Challenge"
        handleUndo={handleClose}
        handleClose={handleClose}
        handleSave={handleSave}
        open={state.open}
        saveName="START CHALLENGE"
        button={true}
        challengeDashboard={true}
        coach={state.selectedChallengeCoach}
        brief={state.selectedChallengeDescription}
        challengeTitle={state.selectedChallengeTitle}
        challengeIsValidation={state.selectedChallengeIsValidation}
        challengeDifficulty={state.selectedChallengeDifficulty}
        challengeAverageTime={state.selectedChallengeAverageTime}
      />
      {/* {finishedCareer ? <PendingCareersDialog
        finishedCareer={finishedCareer}
        // otherCareers={otherCareers}
        dialogClose={handleSuccessDialogClose}
        dialogOpen={successDialogOpen}
        isTrial={isTrial}
        dialogTitle={"Career completed"}
        dialogCaption={"Well done! You have completed the career."}
        dialogDiscoverOtherCareers={"Continue with other careers:"}
      /> : null}
      {finishedLearningTopic ? <LearningTopicCompletedDialog
        finishedLearningTopic={finishedLearningTopic}
        dialogClose={handleLearningTopicFinishedOpen}
        dialogOpen={learningTopicFinishedOpen}
      /> : null} */}
    </Layout>
  );
};

export default ChallengeResults;
